module.exports = __webpack_public_path__ + "static/media/f24.dd1ce8e3.svg";